import { getItemByKeysUtil, getMergeSchemaUtil } from "@qjumpers/common-ui";

export function createEnumItemsDefinition(key, arr, nameProperty = "name", idProperty = "id", uniqueItems = true) {
  const uniqueArr = [];
  const seen = new Set();
  arr.forEach((o) => {
    const id = o[idProperty];
    if (!seen.has(id)) {
      seen.add(id);
      uniqueArr.push(o);
    }
  });

  return {
    [key]: {
      type: "array",
      items: {
        type: "string",
        enum: uniqueArr.map((o) => o[idProperty]),
      },
      _enumNames: uniqueArr.map((o) => o[nameProperty]),
      uniqueItems,
    },
  };
}

export function updateApplicationInternalUiSchema(companyName, uiSchema, translator) {
  if (!companyName) return;

  let property = { "ui:customTitle": translator("Form.Application.Internal.Title", { company: companyName }) };
  let array = [];
  var keys = [];

  keys.push("internal");
  getItemByKeysUtil(uiSchema, array, keys);
  array.forEach((a) => {
    a.schema = getMergeSchemaUtil(a, property);
  });
}
